import React from 'react';
import { Link } from 'react-router-dom';
import { SITE_NAME } from '../site';

// Running header (like the top of a book page) for every Paper page except the home title page.
const PaperNav = () => (
  <header className="paper-running">
    <Link to="/" className="paper-running-name">{SITE_NAME}</Link>
    <nav>
      <Link to="/">Contents</Link> · <Link to="/blog/me">Who</Link> · <Link to="/reading">Reading</Link> · <Link to="/blog/new">New</Link>
    </nav>
  </header>
);

export default PaperNav;
